import Papa from "papaparse";

const normalizeHeader = (header, mapping) => mapping[String(header || "").trim().toLowerCase().replace(/\s+/g, "_")] || null;

function mapFields(row, headerMap) {
  const mapped = {};
  Object.entries(row).forEach(([key, value]) => {
    const field = normalizeHeader(key, headerMap);
    if (field && value != null && String(value).trim() !== "") mapped[field] = String(value).trim();
  });
  return mapped;
}

function convertNumbers(mapped, numericFields, rowNumber, errors) {
  let valid = true;
  numericFields.forEach((field) => {
    if (mapped[field] == null) return;
    const number = parseFloat(String(mapped[field]).replace(/[$,]/g, ""));
    if (Number.isNaN(number)) {
      errors.push(`Row ${rowNumber}: ${field} "${mapped[field]}" is not a number — skipped`);
      valid = false;
    } else {
      mapped[field] = field === "year_of_manufacturing" ? parseInt(number, 10) : number;
    }
  });
  return valid;
}

export function parseCsvRows(raw, headerMap, requiredField, numericFields = [], boolFields = []) {
  const result = Papa.parse(raw.trim(), { header: true, skipEmptyLines: true, transformHeader: (h) => h.trim() });
  const fields = result.meta?.fields || [];
  const emptyMessage = "No data rows found — check the header line";
  if (fields.length > 0 && !fields.some((field) => normalizeHeader(field, headerMap))) return { rows: [], errors: [emptyMessage] };
  const errors = [];
  const rows = [];
  (result.data || []).forEach((row, index) => {
    const mapped = mapFields(row, headerMap);
    if (!mapped[requiredField]) {
      errors.push(`Row ${index + 2}: missing "${requiredField}" — skipped`);
      return;
    }
    if (!convertNumbers(mapped, numericFields, index + 2, errors)) return;
    boolFields.forEach((field) => {
      if (mapped[field] != null) mapped[field] = ["true", "yes", "1", "x"].includes(String(mapped[field]).toLowerCase());
    });
    rows.push(mapped);
  });
  if (!rows.length && !errors.length) errors.push(emptyMessage);
  return { rows, errors };
}

export function downloadCsvTemplate(text, filename) {
  const url = URL.createObjectURL(new Blob([text], { type: "text/csv" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

const escapeCsvCell = (cell) => {
  const value = cell == null ? "" : String(cell);
  return /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
};

export function downloadCsvRows(headers, rows, filename) {
  const lines = [headers.join(","), ...rows.map((row) => row.map(escapeCsvCell).join(","))];
  downloadCsvTemplate(lines.join("\n") + "\n", filename);
}
